<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto;"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">景区运营填报</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-form-item
        label="填报日期"
        prop="ReportDate"
        style="display: inline-block;"
      >
        <el-date-picker
          v-model="ruleForm.ReportDate"
          type="date"
          value-format="yyyy-MM-dd"
          :disabled="true"
          style="width:50rem;"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <!-- <el-form-item
        label="填报时段"
        prop="TimeSolt"
        style="display: inline-block;"
      >
        <el-select v-model="ruleForm.TimeSolt" style="width:50rem;" v-bind:disabled="!IsEdit" placeholder="请选择时间段">
          <el-option
            v-for="item in TimeSoltList"
            :key="item.value"
            :label="item.lable"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item
        label="售票张数"
        prop="TicketData"
        style="display: inline-block;"
      >
        <el-input
          v-model="ruleForm.TicketData"
          type="number"
          step="1"
          min="0"
          style="width:50rem;"
          v-bind:disabled="!IsEdit"
          placeholder="请填写售票张数"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="售票金额"
        prop="Income"
        style="display: inline-block;"
      >
        <el-input
          v-model="ruleForm.Income"
          style="width:50rem;"
          v-bind:disabled="!IsEdit"
          placeholder="请填写售票金额"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="检票人数"
        prop="VisitorData"
        style="display: inline-block;"
      >
        <el-input
          v-model="ruleForm.VisitorData"
          type="number"
          step="1"
          min="0"
          style="width:50rem;"
          v-bind:disabled="!IsEdit"
          placeholder="请填写检票人数"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="出园人数"
        prop="OutGardenNum"
        style="display: inline-block;"
      >
        <el-input
          v-model="ruleForm.OutGardenNum"
          type="number"
          step="1"
          min="0"
          style="width:50rem;"
          v-bind:disabled="!IsEdit"
          placeholder="请填写出园人数"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="全园经济收入"
        prop="Turnover"
        style="display: inline-block;"
      >
        <el-input
          v-model="ruleForm.Turnover"
          style="width:50rem;"
          v-bind:disabled="!IsEdit"
          placeholder="请填写全园经济收入"
        ></el-input>
      </el-form-item>

      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >提交</el-button
        >
        <!--      <el-button @click="resetForm('')" :disabled="!IsEdit" v-if="IsEdit">重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
// import waitAll from "../../../../../../utils/src/waitAll";

export default {
  name: "ScenicAdd",
  controller: "UI",
  action: "ScenicAdd",
  data() {
    return {
      TimeSoltList: [
        {
          lable: '上午',
          value: '0'
        },
        {
          lable: '下午',
          value: '1'
        }
      ],
      ruleForm: {
        // ID: '',
        // ReportDate: '', //上报日期
        // TimeSolt: '', //时间段
        // TicketData: '', //售票张数
        // Income: '', //售票金额
        // VisitorData: '', //接待游客量
        // OutGardenNum: '', //出园游客量
        // Turnover: '', //全园经济收入
        // CompanyId: this.user.Departments[0].OrgId,  //企业ID（登录人的部门）
        // CompanyName: this.user.Departments[0].OrgName, //企业名称（登录人的部门名称）
        // CreateTime: '', //创建时间
        // Creater: this.user.UserName //创建人
      },
      rules: {
        ReportDate: [
          { required: true, message: "请选择填报日期", trigger: "blur" },
        ],
        // TimeSolt: [
        //   { required: true, message: "请选择时间段", trigger: "change" },
        // ],
        TicketData: [
          { required: true, message: "请填写售票张数", trigger: "blur" },
        ],
        Income: [
          { required: true, message: "请填写售票金额", trigger: "blur" },
        ],
        VisitorData: [
          { required: true, message: "请填写检票人数", trigger: "blur" },
        ],
        OutGardenNum: [
          { required: true, message: "请填写出园人数", trigger: "blur" },
        ],
        Turnover: [
          { required: true, message: "请填写全园经济收入", trigger: "blur" },
        ],
      },
      IsEdit: false,
      DeviceTypesArr: [],
      RegionData: [],
    };
  },
  created: function() {
    //当前设定的日期时间
    this.ruleForm.ReportDate = new Date()
    
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "look") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  mounted: function() {},
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {                        
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      let that = this;
      if (InfoId) {
        let searchInfo = { ID: InfoId };
        new MyApis.TbTourScenicApi()
          .GeItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            // console.log(r);
            that.ruleForm = r;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.loadingText = "保存中...";
          if (this.$route.query.type == "add") {
            this.Add();
          } else if (this.$route.query.type == "edit") {
            this.Edit();
          }
        } else {
          return false;
        }
      });
    },
    Add() {
      this.ruleForm.ID = ZJApp.ZJUtils.uuid();
      this.ruleForm.CreateTime = new Date();
      this.ruleForm.Creater = ZJApp.ZJUser.current.UserName;
      this.ruleForm.ModifyTime = new Date();
      this.ruleForm.Modifier = ZJApp.ZJUser.current.UserName;
      this.ruleForm.ReportTime = new Date();
      this.ruleForm.CompanyId = this.user.Departments[0].OrgId;
      this.ruleForm.CompanyName = this.user.Departments[0].OrgName;
      this.ruleForm.Validity = 1;

      new MyApis.TbTourScenicApi()
        .AddItem(this.ruleForm)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.logInfo.ActionName = "景区运营信息添加";
          this.logInfo.LogMessage = r
            ? "景区运营信息添加成功"
            : "景区运营信息添加失败";
          this.logInfo.ModuleName = "产业监测填报";
          this.logInfo.PageName = "景区运营基础信息";
          this.addOperationLog();
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    Edit() {
      this.ruleForm.ModifyTime = new Date();
      this.ruleForm.Modifier = ZJApp.ZJUser.current.UserName;

      new MyApis.TbTourScenicApi()
        .UpdateItem(this.ruleForm)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.logInfo.ActionName = "景区运营信息修改";
          this.logInfo.LogMessage = r
            ? "景区运营信息修改成功"
            : "景区运营信息修改失败";
          this.logInfo.ModuleName = "产业监测填报";
          this.logInfo.PageName = "景区运营基础信息";
          this.addOperationLog();
          this.loading = false;
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    }
  }
};
</script>
<style type="text/css"></style>
